import * as React from 'react';
import './vertical-divider.css';

export default class VerticalDivider extends React.PureComponent<{}, {}> {
  render(): JSX.Element {
    return <div className="vertical-divider" />;
  }
}
